//#region Admin Component Imports
import ManageEmailNotificationEvents from "pages/Admin/EmailNotification/ManageEmailNotificationEvents";
import ManageEmailNotificationSettings from "pages/Admin/EmailNotification/ManageEmailNotificationSettings";
import ManageUsers from "../pages/Admin/User/ManageUsers";
import ManageOrganizations from "../pages/Admin/Organization/ManageOrganizations";
import ManageOrganizationDetails from "../pages/Admin/Organization/ManageOrganizationDetails";
import ManageAnnouncement from "../pages/Admin/Announcement/ManageAnnouncement";
import ManageAccessRequest from "../pages/Admin/AccessRequest/ManageAccessRequest";
import ManageLibrary from "../pages/Admin/Library/ManageLibrary";
import ManageBillingLines from "../pages/Admin/BillingLines/ManageBillingLines";
import ManageBillingLinesDetails from "../pages/Admin/BillingLines/ManageBillingLinesDetails";
import ManageCategory from "../pages/Admin/Library/ManageCategory";
import ManagePost from "../pages/Admin/Library/ManagePost";
import ManageTag from "../pages/Admin/Library/ManageTag";
import LibraryPostAccessHistory from "../pages/Admin/Library/LibraryPostAccessHistory";
import ManageOrder from "../pages/Admin/Subscription/ManageOrder";
import ManageOrderDetails from "../pages/Admin/Subscription/ManageOrderDetails";
import ManageSubscription from "../pages/Admin/Subscription/ManageSubscription";
import ManageSubscriptionDetails from "../pages/Admin/Subscription/ManageSubscriptionDetails";
import BillingReview from "../pages/Admin/BillingLines/BillingReview";
//#endregion
//#region Authenticated User Imports
import Store from "../pages/3DSStore/PurchaseProduct/Store";
import Subscriptions from "../pages/3DSStore/Subscriptions/Subscriptions";
import UserAnnouncement from "../pages/3DSStore/Announcement/UserAnnouncement";
import SubscriptionDetails from "../pages/3DSStore/Subscriptions/SubscriptionDetails";
//#endregion
//#region User Setting Imports
import AccountInfo from "../pages/UserSettings/AccountInfo/AccountInfo";
import UserEmailNotification from "../pages/UserSettings/EmailNotification/UserEmailNotification";
//#endregion
//#region DAF Component Imports
import DafUpload from "../pages/DAF/DafUpload";
import ManageDafUploadFile from "../pages/DAF/ManageDafUploadFile";
import ManageDafRequest from "../pages/DAF/ManageDafRequest";
//#endregion

import {
  AdminRoutes,
  AuthenticatedExternalUserRoutes,
  UserSettingRoutes,
  DafUploadRoutes,
  DafVmidRoutes,
  APPROVEDPRODUCTS,
  RESOURCES,
  CertificationWorkflowRoutes
} from "./PageRoutes";
import VmidList from "../pages/DAFVMID/VmidList";
import AcquirerVmidList from "pages/DAFVMID/AcquirerVmidList";
import ManageFeeWaiver from "pages/Admin/FeeWaiver/ManageFeeWaiver";
import FaqAPage from "pages/Admin/FeeWaiver/Faq/FaqAPage";
import FaqBPage from "pages/Admin/FeeWaiver/Faq/FaqBPage";
import FaqCPage from "pages/Admin/FeeWaiver/Faq/FaqCPage";
import CompanyContacts from "pages/UserSettings/CompanyContacts/CompanyContacts";
import ResourcePage from "pages/Static/ResourcePage";
import ApprovedProductsAll from "../pages/ApprovedProducts/ApprovedProductsAll";
import CertificationPackageInfo from "pages/CertificationWorkflow/CertificationPackage/CertificationPackagePage";
import { useAuthContextUser } from "context/AuthContext";
import AdminCertificationPackagesList from "pages/CertificationWorkflow/CertificationPackageList/Admin/AdminCertificationPackagesPage";
import React from "react";
import ExternalCertificationPackagesPage from "pages/CertificationWorkflow/CertificationPackageList/External/ExternalCertificationPackagesPage";
import SelectedVSSClients from "pages/UserSettings/EmailNotification/SelectedVSSClients";

export const AdminOnlyRouteToComponent = [
  { path: AdminRoutes.ANNOUNCEMENT, component: ManageAnnouncement },
  { path: AdminRoutes.MANAGEUSERS, component: ManageUsers },
  { path: AdminRoutes.MANAGEORGANIZATIONS, component: ManageOrganizations },
  {
    path: AdminRoutes.MANAGEORGANIZATION_DETAILS,
    component: ManageOrganizationDetails,
  },
  { path: AdminRoutes.MANAGESUBSCRIPTION_ORDER, component: ManageOrder },
  {
    path: AdminRoutes.MANAGESUBSCRIPTION_ORDER_DETAILS,
    component: ManageOrderDetails,
  },
  {
    path: AdminRoutes.MANAGESUBSCRIPTION,
    component: ManageSubscription,
  },
  {
    path: AdminRoutes.MANAGESUBSCRIPTION_DETAILS,
    component: ManageSubscriptionDetails,
  },
];

export const IsSuperAdminOnlyRouteToComponent = [
  {
    path: AdminRoutes.EMAILNOTIFICATION_SETTINGS,
    component: ManageEmailNotificationSettings,
  },
  { path: AdminRoutes.MANAGEFEEWAIVERS, component: ManageFeeWaiver },
  { path: AdminRoutes.FAQ_A, component: FaqAPage },
  { path: AdminRoutes.FAQ_B, component: FaqBPage },
  { path: AdminRoutes.FAQ_C, component: FaqCPage },
];

export const IsSuperAdminOrLibAdminRouteToComponent = [
  { path: AdminRoutes.ACCESSREQUEST, component: ManageAccessRequest },
];

export const IsSuperAdminORLibAdminWithReportingExportRouteToComponent = [
  {
    path: AdminRoutes.EMAILNOTIFICATION,
    component: ManageEmailNotificationEvents,
  },
]

export const IsSuperAdminOrLibManagerRouteToComponent = [
  { path: AdminRoutes.MANAGELIBRARY, component: ManageLibrary },
  { path: AdminRoutes.MANAGELIBRARY_CATEGORY, component: ManageCategory },
  { path: AdminRoutes.MANAGELIBRARY_POST, component: ManagePost },
  { path: AdminRoutes.MANAGELIBRARY_TAG, component: ManageTag },
  {
    path: AdminRoutes.MANAGELIBRARY_POSTACCESSHISTORY,
    component: LibraryPostAccessHistory,
  },
];

export const IsSuperAdminOrToolsAndLibAdminRouteToComponent = [
  { path: AdminRoutes.MANAGEBILLINGLINES, component: ManageBillingLines },
  {
    path: AdminRoutes.MANAGEBILLINGLINES_DETAILS,
    component: ManageBillingLinesDetails,
  },
];

export const IsSifManagerRouteToComponent = [
  {
    path: AdminRoutes.MANAGEBILLINGLINES_REVIEW,
    component: BillingReview,
  },
];

export const ExternalUserRouteToComponent = [
  {
    path: AuthenticatedExternalUserRoutes.USER_ANNOUNCEMENT,
    component: UserAnnouncement,
  },
];

export const SubscriptionManagerRouteToComponent = [
  // {
  //   path: AuthenticatedExternalUserRoutes.STORE_ACCOUNT_INFO,
  //   component: OrganizationInfo,
  // },
  {
    path: AuthenticatedExternalUserRoutes.SUBSCRIPTIONS,
    component: Subscriptions,
  },
  {
    path: AuthenticatedExternalUserRoutes.SUBSCRIPTION_DETAILS,
    component: SubscriptionDetails,
  },
];

export const StorePurchaseRouteToComponent = [
  { path: AuthenticatedExternalUserRoutes.STORE_PURCHASE, component: Store },
];

export const DafUploadRouteToComponent = [
  {
    path: DafUploadRoutes.DAF_UPLOAD,
    component: DafUpload,
  },
  {
    path: DafUploadRoutes.DAF_UPLOAD_LIST,
    component: ManageDafUploadFile,
  },
  {
    path: DafUploadRoutes.DAF_UPLOAD_REQUEST,
    component: ManageDafRequest,
  },
];

export const DafVmidRouteToComponent = [
  { path: DafVmidRoutes.DAF_VMID_LIST, component: VmidList },
];

export const DafAcquirerVmidRouteToComponent = [
  { path: DafVmidRoutes.DAF_ACQUIRER_VMID_LIST, component: AcquirerVmidList },
];

export const UserSettingRouteToComponent = [
  { path: UserSettingRoutes.USER_ACCOUNT_INFO, component: AccountInfo },
];

export const UserSettingEmailRouteToComponent = [
  {
    path: UserSettingRoutes.USER_EMAIL_NOTIFICATION,
    component: UserEmailNotification,
  },
  {
    path: UserSettingRoutes.USER_EMAIL_NOTIFICATION_SELECTED,
    component:  SelectedVSSClients,
  }
];
export const ApprovedProductsAllRouteToComponent = [
  {
    path: APPROVEDPRODUCTS.APPROVED_PRODUCTS_ALL,
    component: ApprovedProductsAll,
  },
];

export const CompanyContactsRouteToComponent = [
  {
    path: UserSettingRoutes.COMPANY_CONTACTS,
    component: CompanyContacts
  }
]

export const ResoucesRouteToComponent = [
  {
    path: RESOURCES,
    component: ResourcePage
  }
]

export const CertificationWorkflowRouteToComponent = [
  {
    path: CertificationWorkflowRoutes.CERTIFICATION_PACKAGES_LIST,
    component: function Component() {
      const {isExternalUser} = useAuthContextUser();
      return isExternalUser ? <ExternalCertificationPackagesPage />: <AdminCertificationPackagesList />
    }
  },
  {
    path: CertificationWorkflowRoutes.CERTIFICATION_PACKAGES_INFO,
    component: CertificationPackageInfo 
  }
]